import { render, staticRenderFns } from "./ResourceListing.vue?vue&type=template&id=37f9296e&"
import script from "./ResourceListing.vue?vue&type=script&lang=js&"
export * from "./ResourceListing.vue?vue&type=script&lang=js&"
import style0 from "./ResourceListing.vue?vue&type=style&index=0&id=37f9296e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports